const Plugin = require("../common/Plugin");
const AttributesController = require("./AttributesController");
const AttributesModel = require("./AttributesModel");
const LaunchAttributesController = require("./LaunchAttributesController");
const AttributesDialog = require("./AttributesDialog");

/**
 * Plugin for attributes support
 *
 * @constructor
 */
function AttributesPlugin() {
    const self = this;
    let $attributesEntry;

    /**
     * Starts the plugin
     */
    this.start = function() {
        const controller = new AttributesController();
        self.registerController(controller);

        CudaLaunch.controllers.LaunchAttributesController = new LaunchAttributesController(new AttributesDialog());
        self.registerController(CudaLaunch.controllers.LaunchAttributesController);
        CudaLaunch.models.attributes = new AttributesModel();

        /** @type {jQuery} */
        self.addOptionsMenuEntry(
            $.t("common::attributes.title"),
            controller.showAttributesListView,
            50
        ).then(function(entry) {
            $attributesEntry = entry;
        });

        // Show/hide the menu entry depending on whether we have anything to show
        $(document).on("attributesloaded", function(e, categories) {
            if ($attributesEntry && $attributesEntry.toggle) {
                $attributesEntry.toggle(!$.isEmptyObject(categories));
            }
        });

        // Remove the model when the user logs out
        $(document).on("userunauthenticated", function() {
            CudaLaunch.models.attributes.reset();
        });

        // Create a new model and populate it on login
        $(document).on("userauthenticated", function() {
            CudaLaunch.models.attributes.loadAttributes();
        });
    };
}

AttributesPlugin.prototype = Plugin;

module.exports = AttributesPlugin;


//////////////////
// WEBPACK FOOTER
// ./attributes/AttributesPlugin.js
// module id = 47
// module chunks = 0